import { locale } from '@/globals/config/localization.config';

const wordSegmenter = new Intl.Segmenter(locale, {
	granularity: 'word',
});

export const getHyphensPropValue = ({
	text,
	threshold,
}: {
	text: string | undefined;
	threshold: number;
}) => {
	if (text == null) {
		return undefined;
	}

	const maxWordLength = Array.from(wordSegmenter.segment(text)).reduce(
		(max, { segment, isWordLike }) =>
			isWordLike ? Math.max(max, segment.length) : max,
		0,
	);
	return maxWordLength >= threshold ? 'auto' : undefined;
};
